import { type ReactElement } from 'react';
import { sgwtConnect } from '@/sgwt/sgwtConnect.ts';
import { ApplicationList } from '@/components/application/applicationList';

export function Applications(): ReactElement {

  if (sgwtConnect.isAuthorized())
    return <ApplicationList />;
}